import { Box, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React, { useState } from 'react';
import axiosService from 'utils/axios';
import { Account } from 'types/entities/types';
import ModalPopup from 'components/Modal/ModalPopup';

interface Props {
  account?: Account;
  accountName?: string;
  onSave: (acccount: Account) => void;
  modalTitle: string;
  isModalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}

interface AccountCreateUpdateError {
  error: string;
}

export default function AddOrEditAccount(props: Props) {
  const { account, accountName = '', onSave, modalTitle, isModalOpen, setModalOpen } = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AccountCreateUpdateError | null>();

  const [nameInput, setNameInput] = useState(account?.name || accountName);
  const [notesInput, setNotesInput] = useState(account?.notes || '');

  const handleSubmit = () => {
    setLoading(true);
    const data = {
      name: nameInput,
      notes: notesInput,
    };
    if (account) {
      // Update existing account
      axiosService
        .patch(`/entities/account/${account.id}/`, data)
        .then(accountData => {
          setLoading(false);
          setError(null);
          onSave(accountData.data);
        })
        .catch(err => {
          setLoading(false);
          setError(err.response.data || {});
        });
    } else {
      // Create new account
      axiosService
        .post('/entities/account/', data)
        .then(accountData => {
          setLoading(false);
          setError(null);
          onSave(accountData.data);
        })
        .catch(err => {
          setLoading(false);
          setError(err.response.data || {});
        });
    }
  };

  return (
    <ModalPopup
      title={modalTitle}
      open={isModalOpen}
      onClose={() => setModalOpen(false)}
      actionButtons={
        <LoadingButton
          loading={loading}
          onClick={handleSubmit}
          type="submit"
          fullWidth
          variant="contained"
          disabled={!nameInput}
        >
          {account ? 'Edit account' : 'Create account'}
        </LoadingButton>
      }
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ width: '100%', mt: 1 }}>
          {error ? <Typography>{error.error}</Typography> : null}
          <TextField
            fullWidth
            autoFocus
            required
            margin="normal"
            id="name"
            label="Name"
            value={nameInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNameInput(event.target.value);
            }}
          />
          <TextField
            fullWidth
            minRows={5}
            multiline
            margin="normal"
            id="notes"
            label="Notes"
            value={notesInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNotesInput(event.target.value);
            }}
          />
        </Box>
      </Box>
    </ModalPopup>
  );
}
